import {
  ContactListItem,
  CreateParams,
  GroupListItem,
  QueryListParams,
  ContactsBulkUpdateParams,
} from '.';
import { EXPRESS_API } from 'configs/api/expressApi';
import { AxiosRequestConfig } from 'axios';

export const getContacts = async ({
  groupId,
  page = 0,
  size = 10,
  search,
  sort,
  conversation,
}: QueryListParams) => {
  const start = page * size;
  const { data } = await EXPRESS_API.get('/contacts', {
    params: {
      start,
      groupId,
      limit: size,
      search,
      sort,
      conversation,
    },
  });
  const contacts: ContactListItem[] = data?.contacts || [];
  const count: number = data?.count || 0;
  return { count, contacts };
};

export const getContact = async (id: string) => {
  const respose = await EXPRESS_API.get(`/contacts/${id}`);
  return respose.data;
};

export const getContactGroups = async (id: string) => {
  const response = await EXPRESS_API.get(`/contacts/${id}/groups`);
  return response.data;
};

export const mergeGroups = async (data: { ids: number[]; name: string }) => {
  const response = await EXPRESS_API.post('/groups/merge', data);
  return response.data;
};

export const removeGroupContact = async (contactId: any, groupId: any) => {
  const response = await EXPRESS_API.delete(`/groups/${groupId}/contact`, {
    data: contactId,
  });
  return response.data;
};

export const getContactEvents = async (config: AxiosRequestConfig) => {
  const response = await EXPRESS_API.get('/emailreceiver', config);
  return response.data;
};

export const createContact = async ({ data }: CreateParams) => {
  // @ts-ignore
  delete data.contactId;

  const response = await EXPRESS_API.post('/contacts', data);
  return response.data;
};

export const updateContact = async (data: any) => {
  const response = await EXPRESS_API.put(`/contacts/${data.contactId}`, data);
  return response.data;
};

export const updateMultipleContacts = async (
  data: ContactsBulkUpdateParams
) => {
  const response = await EXPRESS_API.put('/contacts', data);
  return response.data;
};

export const createContacts = async ({ data }: CreateParams) => {
  const response = await EXPRESS_API.post('/contacts/bulk', data);
  return response.data;
};

export const deleteContacts = async ({ data }: CreateParams) => {
  const response = await EXPRESS_API.delete('/contacts', { data });
  return response.data;
};

export const deleteAllContacts = async ({ data }: CreateParams) => {
  const response = await EXPRESS_API.delete('/contacts/delete-all', {
    data: { ids: data },
  });
  return response.data;
};

export const getGroups = async ({
  page = 0,
  size = 10,
  search,
  sort,
  order = '',
}: QueryListParams) => {
  const start = page * size;
  const params = {
    start,
    limit: size,
    search: search,
    sort: sort,
    order,
  };

  const { data } = await EXPRESS_API.get('/groups', { params });
  const groups: GroupListItem[] = data?.groups || [];
  const count: number = data?.count || 0;
  return { groups, count };
};

export const getGroup = async ({ groupId }: Partial<GroupListItem>) => {
  const response = await EXPRESS_API.get(`/groups/${groupId}`);
  const group = response?.data || {};
  return { group };
};

export const createGroup = async ({ data }: CreateParams) => {
  const response = await EXPRESS_API.post('/groups', data);
  return response.data;
};

export const deleteGroups = async ({ data }: CreateParams) => {
  const response = await EXPRESS_API.delete('/groups', { data });
  return response.data;
};

export const updateGroup = async (data: GroupListItem) => {
  const response = await EXPRESS_API.put(`/groups/${data.groupId}`, data);
  return response.data;
};

export const getOptOuts = async ({
  page = 0,
  size = 10,
  search,
  sort,
}: QueryListParams) => {
  const start = page * size;
  const params = {
    start,
    limit: size,
    search,
    sort,
  };

  const { data } = await EXPRESS_API.get('/opt-outs', { params });

  const optOuts = data?.optOutContacts || [];
  const count = data?.count || 0;
  return { optOuts, count };
};
